import { createAction } from '@ngrx/store';

export const noop = createAction('[Shared] Do nothing');
